/* eslint-disable */
import React from "react";
import { Button, Col, Row, Typography, Alert, Spin } from "antd";
import { PiBriefcaseBold, PiArrowClockwiseBold } from "react-icons/pi";

import {
    JobsListContainer,
    StoredJobsButton
} from "../StyledComponents";

import {JobPoolItemAi} from "../JobPoolItemAi.tsx";

const { Text } = Typography;

export interface JobsListComponentProps {
    state: {
        showJobsList?: boolean;
        jobs?: any[];
        matchedJobs?: any[];
        jobsError?: string;
        isLoadingJobs?: boolean;
    };
    onStateChange?: (updater: (prev: any) => any) => void;
    onRefreshJobs?: () => void;
    sessionId?: string | null;
    messages?: any[];
    messagesLoading?: boolean;
    onViewChat?: () => void;
    sessionContext?: any;
    onJobClick?: (jobId: string) => void;
    requiresSubscription?: boolean;
}

export const JobsListComponent: React.FC<JobsListComponentProps> = ({
    state,
    onRefreshJobs,
    onJobClick,
    requiresSubscription = false
}) => {

    // Show loading state when retrying to fetch jobs
    if (state.isLoadingJobs && (!state.matchedJobs || state.matchedJobs.length === 0)) {
        return (
            <div style={{ padding: '40px', textAlign: 'center', display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '16px' }}>
                <Spin size="large" />
                <Text style={{ fontSize: '16px', color: '#666' }}>
                    Ihre Jobs werden geladen...
                </Text>
                <Text style={{ fontSize: '14px', color: '#999' }}>
                    Die Jobsuche dauert etwas länger. Bitte warten Sie einen Moment.
                </Text>
            </div>
        );
    }

    if (!state.showJobsList && !state.matchedJobs?.length) {
        return (
            <div style={{ padding: '40px', textAlign: 'center', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <PiBriefcaseBold size={48} style={{ color: '#ccc', marginBottom: '16px' }} />
                <Text style={{ fontSize: '16px', color: '#666' }}>
                    No jobs found yet. Start a conversation to find matching jobs.
                </Text>
                {onRefreshJobs && (
                    <div style={{ marginTop: '16px' }}>
                        <Button
                            type="primary"
                            icon={<PiArrowClockwiseBold />}
                            onClick={onRefreshJobs}
                        >
                            Search Jobs
                        </Button>
                    </div>
                )}
            </div>
        );
    }


    if (!state.matchedJobs?.length) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <PiBriefcaseBold size={48} style={{ color: '#ccc', marginBottom: '16px' }} />
                <Text style={{ fontSize: '16px', color: '#666' }}>
                    No jobs found yet. Start a conversation to find matching jobs.
                </Text>
                {onRefreshJobs && (
                    <div style={{ marginTop: '16px' }}>
                        <Button
                            type="primary"
                            icon={<PiArrowClockwiseBold />}
                            onClick={onRefreshJobs}
                        >
                            Search Jobs
                        </Button>
                    </div>
                )}
            </div>
        );
    }

    // const handleDeleteJob = (jobId: string) => {
    //     console.log(jobId);
    //    // handle delete
    // };
    //
    // const onCoverLetterClick = async (job: any) => {
    //     try {
    //         if (job.id) {
    //             // Fetch complete job details including description
    //             const { getJobById, startXanoAiCoverLetterSession } = await import('../../../../services/api.ts');
    //             const fullJobDetails = await getJobById(job.id.toString());
    //
    //             const title = fullJobDetails.title || '';
    //             const description = fullJobDetails.description || '';
    //             const jobRole = [title, description].filter(Boolean).join('\n\n') || 'Job Position';
    //
    //             // Start session with job details
    //             const sessionResponse = await startXanoAiCoverLetterSession(jobRole, job.id);
    //             navigate(`/cover-letter/${sessionResponse.session_id}`);
    //         } else {
    //             // For AI jobs without ID, start session with available data
    //             const title = job.title || '';
    //             const description = job.description || '';
    //             const jobRole = [title, description].filter(Boolean).join('\n\n') || 'Job Position';
    //
    //             const { startXanoAiCoverLetterSession } = await import('../../../../services/api.ts');
    //             const sessionResponse = await startXanoAiCoverLetterSession(jobRole);
    //             navigate(`/cover-letter/${sessionResponse.session_id}`);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching AI job details or starting session:', error);
    //     }
    // };
    return (
        <JobsListContainer>
            {state.jobsError && (
                <Alert
                    message={state.jobsError}
                    type="error"
                    closable
                    style={{ marginBottom: '16px' }}
                />
            )}
                <Row gutter={[16, 16]}>
                    {state.matchedJobs.map((job) => (
                        <Col xs={24} sm={12} lg={24} key={job.job_id}>
                            <JobPoolItemAi
                                item={job}
                                onJobClick={onJobClick}
                                requiresSubscription={requiresSubscription}
                            />
                        </Col>
                    ))}
                </Row>
        </JobsListContainer>
    );
};

export interface StoredJobsButtonComponentProps {
    state: {
        hasStoredJobs?: boolean;
        matchedJobs?: any[];
    };
    onStateChange: (updater: (prev: any) => any) => void;
}

export const StoredJobsButtonComponent: React.FC<StoredJobsButtonComponentProps> = ({ state, onStateChange }) => {
    if (!state.hasStoredJobs) {
        return null;
    }

    const handleClick = () => {
        onStateChange(prev => ({
            ...prev,
            showJobsList: true
        }));
    };

    return (
        <StoredJobsButton onClick={handleClick}>
            <PiBriefcaseBold size={18} />
            View Matched Jobs
        </StoredJobsButton>
    );
};

